module.exports = __webpack_public_path__ + "static/media/order_icon_white.199991c3.svg";